<h2 class="option-title" mat-dialog-title>Alert Settings <i class="option-subtitle">(sampled every 3 minutes)</i></h2>
<mat-dialog-content class="options-container">

  <mat-tab-group>

    <mat-tab label="Standard">
       <ng-container *ngFor="let opt of options">
        <div class="option-row" *ngIf="opt.alertType == 'Standard'">
          <mat-checkbox class="option-checkbox" [(ngModel)]="opt.selected" (change)="onToggle(opt)">
            {{ opt.label }}
          </mat-checkbox>
          <select *ngIf="opt.selected" class="option-operator" id="operator-{{opt.name}}" [(ngModel)]="opt.lessThan" required>
            <option [ngValue]="true">&lt;</option>
            <option [ngValue]="false">&gt;</option>
          </select>
          <input *ngIf="opt.selected"
            class="option-value"
            type="number"
            placeholder="Enter value"
            [(ngModel)]="opt.inputValue"
            (ngModelChange)="opt.inputValue = $event === '' ? null : $event"
            required
            aria-label="Threshold value"
          />
        </div>
       </ng-container>
    </mat-tab>

    <mat-tab label="Counters">
      <ng-container *ngFor="let opt of options">
        <div class="option-row" *ngIf="opt.alertType == 'Counter'">
          <mat-checkbox class="option-checkbox" [(ngModel)]="opt.selected" (change)="onToggle(opt)">
            {{ opt.label }}
          </mat-checkbox>
          <select *ngIf="opt.selected" class="option-operator" id="operator-{{opt.name}}" [(ngModel)]="opt.lessThan" required>
            <option [ngValue]="true">&lt;</option>
            <option [ngValue]="false">&gt;</option>
          </select>
          <input *ngIf="opt.selected"
            class="option-value"
            type="number"
            placeholder="Enter value"
            [(ngModel)]="opt.inputValue"
            (ngModelChange)="opt.inputValue = $event === '' ? null : $event"
            required
            aria-label="Threshold value"
          />
        </div>
      </ng-container>
    </mat-tab>

    <mat-tab label="Extractors">
      <ng-container *ngFor="let opt of options">
        <div class="option-row" *ngIf="opt.alertType == 'Extractor'">

          <mat-checkbox class="option-checkbox" [(ngModel)]="opt.selected" (change)="onToggle(opt)">
            {{ opt.label }}
          </mat-checkbox>

          <select *ngIf="opt.selected" class="option-operator" id="operator-{{opt.name}}" [(ngModel)]="opt.lessThan" required>
            <option [ngValue]="true">&lt;</option>
            <option [ngValue]="false">&gt;</option>
          </select>

          <input *ngIf="opt.selected"
            class="option-value"
            type="number"
            placeholder="Enter value"
            [(ngModel)]="opt.inputValue"
            (ngModelChange)="opt.inputValue = $event === '' ? null : $event"
            required
            aria-label="Threshold value"
          />

          <label *ngIf="opt.selected"
            matTooltipClass="multiline-tooltip"
            matTooltip="The amount of time in seconds with no data before
            an alert is triggered. Leave empty for no time limit."
            class="option-label">Idle Timeout:</label>

          <input *ngIf="opt.selected"
           class="option-value"
            type="number"
            placeholder="Idle time"
            [(ngModel)]="opt.idleWindow"
            (ngModelChange)="opt.idleWindow = $event === '' ? null : $event"
            required
            aria-label="Idle Window"
          />

        </div>
      </ng-container>
    </mat-tab>

  </mat-tab-group>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button class="action-btn cancel-btn" (click)="onCancel()">Cancel</button>
  <button mat-button class="action-btn ok-btn" color="primary" (click)="onConfirm()" [disabled]="!isFormValid()">OK</button>
</mat-dialog-actions>
